import React, { useEffect, useState } from "react";
import { ShoppingCart, Loader2, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const TR = {
  sk: { buy: "Kúpiť 20 správ za 3 €", ok: "Balíček zaplatený — +20 AI správ 🎉", pro: "PRO a GOLD: 5 správ denne", credits: "Kúpené správy: {c}" },
  en: { buy: "Buy 20 messages for €3", ok: "Pack paid — +20 AI messages 🎉", pro: "PRO & GOLD: 5 messages/day", credits: "Purchased messages: {c}" },
  cs: { buy: "Koupit 20 zpráv za 3 €", ok: "Balíček zaplacen — +20 AI zpráv 🎉", pro: "PRO a GOLD: 5 zpráv denně", credits: "Koupené zprávy: {c}" },
  de: { buy: "20 Nachrichten für 3 € kaufen", ok: "Paket bezahlt — +20 KI-Nachrichten 🎉", pro: "PRO & GOLD: 5 Nachrichten/Tag", credits: "Gekaufte Nachrichten: {c}" },
  pl: { buy: "Kup 20 wiadomości za 3 €", ok: "Pakiet opłacony — +20 wiadomości AI 🎉", pro: "PRO i GOLD: 5 wiadomości dziennie", credits: "Kupione wiadomości: {c}" },
  fr: { buy: "Acheter 20 messages pour 3 €", ok: "Pack payé — +20 messages IA 🎉", pro: "PRO & GOLD : 5 messages/jour", credits: "Messages achetés : {c}" },
};

export const aiPackTr = (lang) => TR[lang] || TR.sk;

export function AiPackGate({ message, lang }) {
  const t = aiPackTr(lang);
  const [busy, setBusy] = useState(false);
  const buy = async () => {
    setBusy(true);
    try {
      const r = await api.post("/ai/buy-pack", { origin_url: window.location.origin, kind: "ai_pack" });
      window.location.href = r.data.url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
      setBusy(false);
    }
  };
  return (
    <div className="border border-gold-700/60 bg-gold-500/5 p-4 space-y-3" data-testid="ai-pack-gate">
      <p className="text-sm text-zinc-200 leading-relaxed">{message}</p>
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={buy} disabled={busy} data-testid="ai-buy-pack-btn"
                className="wb-btn-primary px-4 py-2 text-xs inline-flex items-center gap-1.5 disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ShoppingCart className="w-3.5 h-3.5" />} {t.buy}
        </button>
        <Link to="/pricing" className="text-xs underline text-amber-300" data-testid="ai-pack-pro-link">{t.pro}</Link>
      </div>
    </div>
  );
}

export function useAiPackReturn(lang) {
  const [credits, setCredits] = useState(null);
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const sid = p.get("session_id");
    if (p.get("pack") !== "success" || !sid) return;
    window.history.replaceState({}, "", "/ai-advisor");
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/ai/pack-status/${sid}`);
        if (r.data.paid) { setCredits(r.data.quota.credits); toast.success(aiPackTr(lang).ok); return; }
      } catch { /* retry */ }
      if (++tries < 8) setTimeout(poll, 2500);
    };
    poll();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return credits;
}

export function AiCreditsBadge({ credits, lang }) {
  if (!credits) return null;
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-mono text-emerald-400" data-testid="ai-credits-badge">
      <Sparkles className="w-3 h-3" /> {aiPackTr(lang).credits.replace("{c}", credits)}
    </span>
  );
}
